import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';

interface IForgottenPasswordFormProps {
  handleSubmit: () => void;
  actions: {
    push: (route: string) => void;
  };
}

class ForgottenPasswordForm extends React.Component<IForgottenPasswordFormProps> {
  public render() {
    const { handleSubmit } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Name
          </Col>
          <Col sm={5}>
            <Field
              type="text"
              name={'firstName'}
              placeholder="Forename"
              component={FieldFormControl}
            />
          </Col>
          <Col sm={4}>
            <Field
              type="text"
              name={`lastName`}
              placeholder="Surname"
              component={FieldFormControl}
            />
          </Col>
        </FormGroup>
        {/*<FormGroup controlId="dob">*/}
          {/*<Col componentClass={ControlLabel} sm={3}>*/}
            {/*Date of Birth*/}
          {/*</Col>*/}
          {/*<Col sm={3}>*/}
            {/*<Field*/}
              {/*name={'dob'}*/}
              {/*type="masked-date"*/}
              {/*placeholder="dd/mm/yyyy"*/}
              {/*className="form-control"*/}
              {/*component={FieldFormControl}*/}
            {/*/>*/}
          {/*</Col>*/}
        {/*</FormGroup>*/}
        <FormGroup controlId="email">
          <Col componentClass={ControlLabel} sm={3}>
            Your email address
          </Col>
          <Col sm={5}>
            <Field
              type="email"
              name={'email'}
              component={FieldFormControl}
              placeholder="email@domain.com"
            />
          </Col>
        </FormGroup>
        <div className="btn-bar section">
          <Link to="/auth/login" className="pull-left btn-secondary back-btn btn">
            Back
          </Link>
          <Button
            type="submit"
            className="pull-right btn-secondary"
          >
            Reset
          </Button>
        </div>
      </Form>
    );
  }
}

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  connect(
    null,
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ForgottenPasswordForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ForgottenPassword/components/ForgottenPasswordForm/index.tsx